import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-loading-screen" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Loading Serato Visualizer", -1)

import LoadingSpinner from '@/components/LoadingSpinner.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'MainLoadingScreen',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LoadingSpinner),
    _hoisted_2
  ]))
}
}

})